export interface IMicrositeRecipientCommunication {
    id: number,
    micrositeRecipientId: number,
    note: string,
    reply: string,
    statusId: number,
    status: string,
    sendDateTime: string,
    viewDateTime: string,
    replyDateTime: string,
    sentByRecipient: boolean
}